export const staticStrings = {
  growBusiness: 'Grow your business with JioPay',
  talkto: 'Talk To Us',
  signup: 'Sign Up',
  whyjio: 'Why use JioPay?',
  incCon: 'Increase conversions',
  wide: 'Widen presence',
  risk: 'Mitigate risk',
  experience: 'Simplified experience',
  products: 'Products',
  direct: 'JioPay Direct',
  subscribe: 'JioPay Subscribe',
  invoice: 'JioPay Invoice',
  market: 'JioPay Marketplace',
  bill: 'JioPay BillMe',
  devs: 'Developers',
  docs: 'Developer Documentation',
  apiRef: 'API Reference',
  more: 'More',
  about: 'About',
  terms: 'Privacy Terms',
  pricing: 'Pricing',
  merchantPartner: 'Our merchant partners',
  partnerSay: 'Our partners say',
  partnerSayText:
    'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
  contact: 'Contact Us',
  partnerProgram: 'Partner Program',
  jiopayForConsumers: 'JioPay for Consumers',
  signin: 'Sign In',
  conditions: 'Terms & Conditions',
  digitalPayments: 'Digital payment acceptance made easy, by JioPay.',
  exploreProductsLabel: 'Explore Products',
  acceptPayment: 'The best way to get paid online',
  acceptPaymentTab: 'The best way to get paid online',
  mops100Plus: '100+\nPayment\nMethods\nSupported',
  pgPara: 'Collect payments online on your own custom website or through tailored links and pages',
  posPara: 'A smart terminal to accept in-store payments from multiple payment modes including Cards and UPI',
  upiHubPara: 'A comprehensive platform that lets you collect payments using the versatile UPI as a payment method',
  billerPara: 'A platform that enables payment acceptance for recharges and bill payments of service providers',
  whyJioPara: 'We are obsessed with technology and use it extensively to solve the payments needs of your business',
  vesatilePara:
    'Multiple feature launches, optimizations and improvements through the year to ensure you are always ahead of the curve',
  compPara:
    'Reduce your operational expenses using our fully managed platform that is designed for Security, Reliability and Scale',
  compliantPara: 'JioPay meets the highest standards to meet compliance needs and reassure your decision to choose us',
  robustPara:
    'Our integration with multiple institutions ensures the best fail-safe to deliver superior success rates and uptime',
  posSubTitle: 'The smartest way to accept in-person payments',
  upiHubSubTitle: 'Experience the versatile suite of UPI products from JioPay',
  billerSubTitle: 'Collect payments seamlessly from your users for your entity',
  acceptPaymentsPara:
    'JioPay is the most effective and efficient platform to accept internet payments in India. With state of the art infra, class leading risk and fraud engines and a plethora of options, accepting payments has never been this simple!',
  businessNeeds: 'Everything your business needs',
  businessNeedsTab: `Everything your
business needs`,
  businessPara:
    'Jio Pay has the ideal solution for your business needs. Our innovation at scale, experience and immense understanding of the Indian market can do wonders for your business. Be it marketplace payments, subscription payments or on-demand payments on the go, we help deliver the best experience for your users.',
  enablesPayment: 'Explore how JioPay can solve your payment needs',
  developerCen: 'Developer centric product',
  developerCenTab: `Developer centric
product`,
  developerCenPara:
    'Integrating with JioPay lets you offer your users multiple ways to pay – and we’re adding more frequently. Build and test with Jio Pay on sandbox. When you’re done, start collecting user payments instantly',
  exploreDocs: 'Explore the developer docs',
  payDirect: 'JioPay Direct',
  payDirectText: 'Get paid by your users anytime and anywhere',
  paySubscribe: 'JioPay Repeat',
  paySubscribeText: 'Bill users automatically on a recurring basis',
  payInvoice: 'JioPay Collect',
  payInvoiceText: 'Create digital payment links after fulfilment',
  payMarket: 'JioPay Onward',
  payMarketText: 'Accept user payments and settle them multi-sided between sellers',
  payBills: 'JioPay BillMe',
  payBillsText: 'Collect payment for communities & more',
  ourProducts: 'JioPay Products',
  ourProductsLabel:
    'Our platform with its suite of fully integrated products enables you to accept payments seamlessly from your users, be it on websites or in-store.',
  pgProducts: 'JioPay Payment Gateway Products',
  betterSales: 'Better your sales and retention with our carefully crafted checkout experience',
  widePresence: 'Widen presence',
  acrossActive: 'Widen your presence',
  mitigateRisk: 'Mitigate risk & secure data',
  reach3Million: 'Reach millions of unique users across different parts of the country',
  preventFraud: 'Prevent fraudulent transactions while processing genuine orders',
  omniChannel: 'Omni channel experience',
  uniqueExp: 'Create unique experiences that are specific to your product',
  privacyPolicyLink: 'https://jiopay.in/business/privacy-policy',
  tncLink: 'https://www.jiomoney.com/privacy.html',
  playStoreLink: 'https://play.google.com/store/apps/details?id=com.jiopay.business',
  aboutUs:
    'JioPay was created with the sole intention of creating a product that could revolutionize payments, facilitate quick and simple transactions without having a complex integration process for our users - the merchants of India. JioPay offers simple, self-service products for merchants and businesses of all sizes to accept payments online from their customers.\n\nJioPay products are tailor-made to the business needs of merchants in Bharat.\n\nWith JioPay, merchants can accept payments from all digital modes including Cards of all types, UPI, Netbanking, Wallets and Bill Now, Pay Later among others',
  simpleInstantUpi: 'Simple, instant UPI payments from your customers',
  simpleInstantUpiTab: `Simple, instant UPI payment 
from your customers`,
  jiobizzLabel: 'Start accepting UPI payments from your customers instantly irrespective of which UPI app they use.',
  acceptPayments: 'Accept payment from all UPI apps',
  supportEmail: 'merchant.support@jiopay.in',
  copyright: 'Copyright © 2020 Jio Payment Solutions Limited (formerly known as Reliance Payment Solutions Limited).',
  downloadApp: 'Download the app from Google Play Store now and start accepting payment',
  frequentlyAsked: 'Frequently Asked Questions',
  aboutBusiness: 'About JioPay Business',
  modernDeviceTitle: 'Modern smart devices meets state-of-the-art software and infrastructure',
  modernDeviceSubTitle:
    'Our platform with its suite of fully integrated products enables you to accept payments seamlessly from your users, be it on websites or in-store.',
  jiopay1Qr: 'JioPay 1QR',
  jiopay1QrSubTitle:
    'Choose a QR product from the comprehensive suite of solutions that JioPay offers. Deploy a static QR or generate one for each transaction for either in-store or after-delivery to collect payments from your users. You can also opt to deploy the JioPay digital standee to add that additional zing to your store.',
  omniChannelTitle: 'Truly Omnichannel',
  omniChSubTitle:
    'Blur the lines between your online and offline business and their respective payments with JioPay UPI Hub',
  goBeyondSubTItle:
    'Push the boundaries with JioPay UPI Hub. Issues your own handles to your users and unlock the untapped potential of the UPI platform',
  bharatPayTitle: 'Collect easily across Bharat',
  bharatPaySubTitle:
    'JioPay Biller Center helps you connect to BBPS which makes payment collection across the country easy and effortless.',
  talkToUsTitle: 'Enable your users to pay for different services',
  talktoUsPara:
    'If you are a business looking for ways to allow your users to pay bills of different essentials and utilities, we have you covered',
  emailus: 'Email us for any query at',
  consumerSafeSecure: 'Safe, Secure & Swift, Payments by JioPay',
  builtForBharat: '\n is built\naround in India\n  for bharat\n   users\n knowing\n   your\n',
  consumerEasiest: 'JioPay is the easiest way to make your payments everyday',
  consumerPayAnywhere: 'Pay anyone, anywhere with JioPay',
  shopAnywhere: 'Shop anywhere with JioPay',
  payAnywhereSubTitle:
    'You can pay your family, friends and chaiwala even if they are not on JioPay. Enjoy no cost payments from your bank account to theirs. It is really that simple!',
  consumerRecharge: 'Recharge and pay bills conveniently',
  consumerRechargeSubTitle: 'Never be late for your recharges and bill payments.\nBe on time, every time, with JioPay',
  rewards: 'You pay, JioPay rewards',
  rewardsSubTitle: 'Earn rewards from brands you love',
  safetyAndSecurity: 'Safety & Security, reassured by JioPay',
  safetyAndSecuritySubTitle:
    'JioPay ensures that your money is safe. Our state-of-the-art systems, mitigate risks, frauds and hacks.',
  aboutSubTitle:
    'JioPay is a payments app from the house of Jio. JioPay lets you use UPI to make payments to users. You can also use cards to recharge, pay bills and shop at merchant stores.',
  howToSubTitle:
    'Sign up with your bank phone number, complete the registration and you’re ready to start making payments',
  forBusiness: 'For Business',
  partnerEarnShareSubTitle:
    'Recommend Jiopay Business products to your customers & clients and reap monetary benefits.',
}

export const footerStrings = {
  whyjio: 'Why JioPay?',
  incCon: 'Increase conversions',
  wide: 'Widen presence',
  risk: 'Mitigate risk',
  experience: 'Simplified experience',
  products: 'Products',
  direct: 'Direct',
  more: 'More',
  about: 'About Us',
  privacyPolicy: 'Privacy Policy',
  conditions: 'Terms & Conditions',
  jioPayBuzApp: 'JioPay Business App',
  repeat: 'Repeat',
  collect: 'Collect',
  campaign: 'Campaign',
  mobileCheckout: 'Mobile Checkout',
  grievancePolicy: 'Grievance Redressal Policy',
  billpayTermsAndCond: 'BillPay Terms & Conditions',
  onboardAndKyc: 'Merchant Onboarding & KYC-AML Policy',
  investorRelation: 'Investor Relations',
  compliantResolutionNescalation: 'Complaint Resolution and Escalation Matrix',
  faq: 'FAQs',
  general: 'General',
  help: 'Help Center',
  compliantResolution: 'Complaint Resolution',
  jioPayBizConsumer: 'JioPay for Consumers',
  jioPayBizUser: 'JioPay for Users',
  legal: 'Legal',
  pg: 'Payment Gateway',
  pos: 'Point of Sale',
  upi: 'UPI Hub',
  billerCenter: 'Biller Centre',
  upiNote: '* UPI which refers to Unified Payment Interface is a copyrighted and trademarked property of NPCI',
  billerNote: '* BBPS which refers to Bharat Bill Payment System is a copyrighted and trademarked property of NPCI',
  partnerProgram: 'JioPay Business Partner Program',
}
